import { useCallback, useState, useContext, useEffect } from "react";
import {
  addOrgAwardsAward,
  deleteOrgAwards,
} from "../MyProfile/Service/profileService";
import { TostMsg } from "../../../App";
import { EmployeeAwardsGet } from "../AwardList/Services/awardService";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import {
  GetMasterTypeData,
  uploadDoc,
} from "../../../Services/Global-Services/GlobalServices";
import LoginLoader from "../../../Shared/Sidebar/LoginLoader";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";
import { getRawPermissionsArray } from "../../../Routes/AuthGard/usePermissions";
let employeeId;

const OrgAwardSetting = () => {
  const [columns, setColumns] = useState(["Award Name", "Frequency", "Logo"]); // Columns state
  const [rows, setRows] = useState([{}]); // Rows state
  const [editIndex, setEditIndex] = useState(null);
  const [orgAwardList, setOrgAwardList] = useState([]);
  const [selectedId, SetSelectedId] = useState();
  const [awardFrequencyLst, setAwardFrequencyLst] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  const [file, setFile] = useState(null);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [awardsEditId, setAwardsEditId] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  const [IsImageloading, setIsImageloading] = useState(false);
  let toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [deleteContent, setSeleteContent] = useState([]);
  const [create, setCreate] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleted, setDeleted] = useState(false);
  let userPermissions = getRawPermissionsArray();
  const [orgAwardId, setOrgAwardId] = useState(0);
  const [errors, setErrors] = useState({});
    let SearchValue = "";
  const [data, setData] = useState({
    AwardName: "",
    FrequencyName: "",
    awardImage: "",
  });

  useEffect(
    (employeeId) => {
      getMasterTypeList();
      permissionGiven();
      GetOrgAwards();
    },
    [employeeId]
  );

  const validateAwardData = (data, index) => {
    setOrgAwardId(0);
    const newErrors = {};

    newErrors[`${index}-AwardName`] =
      !data.AwardName || data.AwardName.trim() === ""
        ? "Name is required"
        : undefined;

    newErrors[`${index}-FrequencyName`] =
      !data.FrequencyName || data.FrequencyName.trim() === ""
        ? "Frequency is required"
        : undefined;

    newErrors[`${index}-awardImage`] =
      !data.awardImage || data.awardImage === ""
        ? "Image is required"
        : undefined;

    setErrors((prev) => ({ ...prev, ...newErrors }));

    const isValid = Object.values(newErrors).every(
      (error) => error === undefined
    );
    return isValid;
  };

  async function getMasterTypeList() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "AwardFrequency",
    };
    try {
      const data = await GetMasterTypeData(params);
      setAwardFrequencyLst(data?.Data);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  const permissionGiven = () => {
    userPermissions?.map((UserPermission) => {
      if (UserPermission.PermissionName == "Award.Create") {
        setCreate(true);
      } else if (UserPermission.PermissionName == "Award.Update") {
        setUpdate(true);
      } else if (UserPermission.PermissionName == "Award.Delete") {
        setDeleted(true);
      }
    });
  };

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  async function GetOrgAwards() {
    setIsloading(true);
    let body = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let responce = await EmployeeAwardsGet(body);
      setOrgAwardList(responce?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.AwardMasterData);
    } finally {
      setIsloading(false);
    }
  }

  const handleAddRow = () => {
    setOrgAwardList([
      ...orgAwardList,
      { AwardName: "", FrequencyName: "", awardImage: "" },
    ]);
    setEditIndex(orgAwardList.length);
  };

  const handleRemoveRow = () => {
    setRows(rows.slice(0, -1));
  };

  const handleRemoveSpecificRow = (rowIdx) => () => {
    const updatedRows = rows.filter((_, idx) => idx !== rowIdx);
    setRows(updatedRows);
  };

  const handleChange = (rowIdx, colName) => (e) => {
    const { value } = e.target;
    const updatedRows = [...orgAwardList];
    updatedRows[rowIdx] = { ...updatedRows[rowIdx], [colName]: value };
    setOrgAwardList(updatedRows);
    const updatedData = { ...data, [colName]: value };
    setData(updatedData);
    // validateAwardData(updatedData, rowIdx);
  };

  const handleFileChange = useCallback(async (event, index) => {
    const selectedFile = event.target.files;
    setFile({ files: selectedFile, index });
  }, []);
  const cancelAward = () => {
    setOrgAwardId(0);
    GetOrgAwards();
    setOrgAwardList((prevList) => {
      setEditIndex(null);
      const lastItem = prevList[prevList.length - 1];
      const isEmpty =
        !lastItem.AwardName && !lastItem.FrequencyName && !lastItem.awardImage;

      if (isEmpty) {
        return prevList.slice(0, -1);
      }
      return prevList;
    });
  };

  useEffect(() => {}, [selectedId]);
  
  async function addAwardOrg(index, data) {
    let selectedFrequencyIdId;
    if (selectedId) {
      selectedFrequencyIdId = selectedId;
    } else {
      selectedFrequencyIdId = data?.FrequencyId;
    }
    const body = {
      ModifiedBy: userDetails.EmpId ?? 0,
      FrequencyId: Number(selectedFrequencyIdId) ?? 0,
      OrgId: userDetails?.OrgId,
      Id: data?.id ?? 0,
      AwardName: data.AwardName,
      AwardImage: data.awardImage,
    };
    try {
      await addOrgAwardsAward(body);
      setOrgAwardId(0);
      if (awardsEditId) {
        GetMasterSystemAlertList("Award_Updated", 0);
      } else {
        GetMasterSystemAlertList("Award_Added", 0);
      }
      SetSelectedId(null);
      setOrgAwardList([]);
      setEditIndex(null);
      GetOrgAwards();
      setIsloading(false);
    } catch (err) {
      setIsloading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleEditClick = (index, data) => {
    setOrgAwardId(data?.id);
    setEditIndex(index);
  };

  const handleCreatedlstDelete = (Id) => {
    setAwardsEditId(Id);
  };
  async function DeleteAwards() {
    setIsloading(true);
    if (awardsEditId) {
      let body = {
        Id: awardsEditId,
      };
      try {
        let awardDeleteList = await deleteOrgAwards(body);
        if (awardDeleteList) {
          GetMasterSystemAlertList("Award_Deleted", 0);
          setIsloading(false);
          GetOrgAwards();
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  useEffect(() => {
    if (file?.files) {
      uploadPolicyDocFile(file.files, file.index);
    }
  }, [file, orgAwardId]);

  async function uploadPolicyDocFile(files, index) {
    setIsImageloading(true);
    if (files) {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("files", files[i]);
      }
      let params = {
        UploadType: UploadFile_KEYS.OrgAwardSetting,
        RefId: orgAwardId ?? 0,
      };
      try {
        const response = await uploadDoc(params, formData);
        const data = await response;
        const ImageURL = data?.Data;
        if (ImageURL?.[0]) {
          handleChange(
            index,
            "awardImage"
          )({
            target: { value: ImageURL[0] },
          });
        }
        setIsImageloading(false);
      } catch (error) {
        setIsImageloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    } else {
      setIsImageloading(false);
      toster.current.warn("No file selected");
    }
  }

  const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      SearchValue = value;
      let filteredList = orgAwardList.filter((award) =>
        award.AwardName?.toLowerCase().includes(SearchValue?.toLowerCase())
      );
      if (SearchValue != "") {
        setOrgAwardList(filteredList);
      } else {
        GetOrgAwards();
      }
    }, 800),
    [orgAwardList]
  );

  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4"></div>
        <div className="title-text">
          <h3>Award Types ({orgAwardList?.length})</h3>
          <div className="d-flex">
            <InputText
              name="requestTitle"
              className="form-control search-grpname me-2"
              onChange={handleInputChange}
              placeholder="Search"
            />
            {!editIndex && (
              <button
                className="addaward-btn"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-bs-original-title=""
                fdprocessedid="izng1j"
                onClick={handleAddRow}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                </svg>
                Award
              </button>
            )}
          </div>
        </div>
        <div className="col-md-12 column">
          <table className="table table-bordered table-hover" id="tab_logic">
            <thead>
              <tr>
                {columns.map((colName, colIdx) => (
                  <th key={colIdx} className="text-left">
                    {colName}
                  </th>
                ))}
                <th className="text-left" style={{ width: "100px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {orgAwardList?.map((data, index) => (
                <tr key={index}>
                  {editIndex === index ? (
                    <>
                      <td>
                        <input
                          value={data.AwardName}
                          onChange={handleChange(index, "AwardName")}
                          placeholder="Name"
                          className={`form-control ${
                            errors[`${index}-AwardName`] ? "is-invalid" : ""
                          }`}
                        />
                        {errors[`${index}-AwardName`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-AwardName`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <select
                          onChange={(e) => {
                            const selectedId = e.target.value;
                            SetSelectedId(selectedId);
                            const selectedOption = awardFrequencyLst.find(
                              (opt) => Number(opt.Id) === Number(selectedId)
                            );
                            handleChange(
                              index,
                              "FrequencyName"
                            )({
                              target: {
                                value: selectedOption?.Name || "",
                              },
                            });
                          }}
                          value={
                            awardFrequencyLst.find(
                              (opt) => opt.Name === data.FrequencyName
                            )?.Id || ""
                          }
                          className={`form-control ${
                            errors[`${index}-FrequencyName`] ? "is-invalid" : ""
                          }`}
                        >
                          <option value="" disabled>
                            Choose...
                          </option>
                          {awardFrequencyLst?.map((option) => (
                            <option key={option.Id} value={option.Id}>
                              {option.Name}
                            </option>
                          ))}
                        </select>
                        {errors[`${index}-FrequencyName`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-FrequencyName`]}
                          </div>
                        )}
                      </td>
                      <td>
                        {" "}
                        <div className="loadresumes">
                          <div className="inner">
                            {data.awardImage ? (
                              <img
                                src={data.awardImage}
                                className="editaddimg"
                              />
                            ) : (
                              <>
                                {IsImageloading ? (
                                  <LoginLoader />
                                ) : (
                                  <img
                                    src="/images/org-img/learn/add.png"
                                    className="editaddimg"
                                  />
                                )}
                              </>
                            )}
                          </div>
                          <label
                            htmlFor={`file-upload-${index}`}
                            className="custom-file-upload"
                          >
                            <i
                              className="fa fa-upload me-2"
                              aria-hidden="true"
                            ></i>
                            Upload Award Image
                         </label>
                          <input
                            type="file"
                            id={`file-upload-${index}`}
                            style={{
                              display: "none",
                            }}
                            accept="image/*"
                            onChange={(e) => handleFileChange(e, index)}
                          />
                          {errors[`${index}-awardImage`] && (
                            <div className="text-danger mt-1">
                              {errors[`${index}-awardImage`]}
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        <>
                          <img
                            onClick={() => {
                              cancelAward();
                            }}
                            src="/images/org-img/profile/close.png"
                            title="Cancel"
                            className="editactions me-2"
                            style={{ width: "17px" }}
                          />
                          <img
                            onClick={() => {
                              if (validateAwardData(data, index)) {
                                addAwardOrg(index, data);
                              }
                            }}
                            src="/images/org-img/profile/check.png"
                            title="Confirm"
                            className="editactions"
                            style={{ width: "17px" }}
                          />
                        </>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{data?.AwardName}</td>
                      <td>{data?.FrequencyName}</td>
                      <td className="">
                        {data?.awardImage ? (
                          <img
                            src={data?.awardImage || defaultImage}
                            onError={handleImageError}
                            style={{
                              width: "auto",
                              height: "30px",
                            }}
                          />
                        ) : (
                          <img src={data?.awardImage} className="w-4" />
                        )}
                      </td>
                      <td className="">
                        <button
                          disabled={editIndex != null}
                          className="editactions me-2"
                          onClick={() => handleEditClick(index, data)}
                        >
                          <img
                            src="/images/tickets/edit-ico.svg"
                            className=""
                            title="Edit"
                          />
                        </button>
                        <button
                          className="editactions"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-Award"
                          onClick={() => {
                            handleCreatedlstDelete(data?.id);
                            GetMasterSystemAlertList("Delete_Award", 1);
                          }}
                        >
                          <img
                            src="/images/tickets/delete.svg"
                            className=""
                            title="Delete"
                          />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal fade" id="delete-Award">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                <p>{deleteContent}</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => DeleteAwards()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrgAwardSetting;
